import {cssTheme} from '../theme'
import {css} from '../theme/css'
import {spacing} from '../theme/theme'

export const classes = {
  link: css`
    padding: ${spacing(1)};
  `,
  avatar: css`
    border-radius: 50%;
  `,
  username: css`
    color: ${cssTheme.default.day.everWhite};

    &:hover,
    &:active {
      color: ${cssTheme.default.day.everWhite};
    }

    margin-inline-end: ${spacing(1.25)};
  `,
  footer: css`
    padding: ${spacing(2, 1)};
  `,
  header: css`
    border-block-end: 1px solid ${cssTheme.default.day.line};
    padding: ${spacing(1, 0)};
  `,
  overflowShadow: css`
    box-shadow: 5px -1px 30px rgb(215 215 215);
  `,
  noWrap: css`
    white-space: nowrap;
  `,
}

// noinspection CssReplaceWithShorthandSafely
export const listClasses = {
  root: css`
    // 55 * 4 = высота одного элемента на кол-во элементов
    // 24     = padding-top + padding-bottom
    // 1      = border-bottom
    max-block-size: ${55 * 4 + 24 + 1}px;
    overflow: auto;
    padding: ${cssTheme.spacingUnits.s} 0;
    border-block-end: 1px solid ${cssTheme.default.day.line};
    // магия с тенями
    // https://lea.verou.me/2012/04/background-attachment-local/
    background: linear-gradient(white 30%, rgba(255, 255, 255, 0)),
      linear-gradient(rgba(255, 255, 255, 0), white 70%) 0 100%,
      radial-gradient(farthest-side at 50% 0, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0)),
      radial-gradient(farthest-side at 50% 100%, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0)) 0 100%;
    background-repeat: no-repeat;
    background-color: white;
    background-size: 100% 40px, 100% 40px, 100% 14px, 100% 14px;
    background-attachment: local, local, scroll, scroll;
  `,
}
